import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

const DeliveryOptionsSelectedTextStyle = css`
  .delivery-option-selection-container {
    width: 100%;
    .delivery-option-selection {
      font-family: 'Lato', sans-serif;
      font-style: normal;
      font-size: 14px;
      line-height: 18px;
      color: ${colors.secondary_color};
      span {
        &.green {
          color: ${colors.green.shade25};
          font-weight: 700;
        }
        &.bold {
          font-weight: 700;
        }
        &.capitalize {
          text-transform: capitalize;
        }
      }
      &.not-found {
        color: ${colors.gray.shade52};
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
      }
      &.locationName {
        color: #717171;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
      }
    }
    .delivery-option-locationName {
      color: #717171;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      display: flex;
      align-items: center;
      gap: 4px;

      .delivery-option-selected-store-info {
        display: flex;
        flex-direction: row;
        gap: 6px;
        .do-info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          gap: 2px;
          .do-locationName {
            color: #717171;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
            text-transform: capitalize;
            margin: 0;
          }
          .available {
            color: #30871f;
            &::before {
              background-image: url('/a/fa/product/static/styles/svg/check.svg');
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
            }
          }
          .not-available {
            color: #cc4e00;
            &::before {
              background-image: url('/a/fa/product/static/styles/svg/notAvailable.svg');
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
            }
          }
        }

        .icon {
          display: inline-block; /* Changed to inline-block for better alignment */
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url('/a/fa/product/static/styles/svg/fcomIcon.svg'); /* Default icon */
          width: 20px;
          height: 16px;
        }
        .sodimac {
          background-image: url('/a/fa/product/static/styles/svg/sodimac.svg');
          width: 20px;
          height: 16px;
        }
        .tottus {
          background-image: url('/a/fa/product/static/styles/svg/tottus.svg');
          width: 22px;
          height: 20px;
        }
        .falabella {
          background-image: url('/a/fa/product/static/styles/svg/falabella.svg');
          width: 11.09px;
          height: 16px;
        }
        .plaza {
          background-image: url('/a/fa/product/static/styles/svg/mPlazaIcon.svg');
          width: 20px;
          height: 20px;
        }
        .chilexpress {
          background-image: url('/a/fa/product/static/styles/svg/chileExpressIcon.svg');
          width: 20px;
          height: 20px;
        }
        .bluexpress {
          background-image: url('/a/fa/product/static/styles/svg/blueexpressIcon.svg');
          width: 20px;
          height: 20px;
        }
        .metro {
          background-image: url('/a/fa/product/static/styles/svg/metroIcon.svg');
          width: 20px;
          height: 20px;
        }
        .etam {
          background-image: url('/a/fa/product/static/styles/svg/etamIcon.svg');
          width: 20px;
          height: 20px;
        }
        .sybilla {
          background-image: url('/a/fa/product/static/styles/svg/sybillaIcon.svg');
          width: 20px;
          height: 20px;
        }
        .americanino {
          background-image: url('/a/fa/product/static/styles/svg/americaninoIcon.svg');
          width: 20px;
          height: 20px;
        }
        .mango {
          background-image: url('/a/fa/product/static/styles/svg/mangoIcon.svg');
          width: 20px;
          height: 20px;
        }
        .aldo {
          background-image: url('/a/fa/product/static/styles/svg/aldoIcon.svg');
          width: 20px;
          height: 20px;
        }
        .clarks {
          background-image: url('/a/fa/product/static/styles/svg/clarksIcon.svg');
          width: 20px;
          height: 20px;
        }
        .carters {
          background-image: url('/a/fa/product/static/styles/svg/cartersIcon.svg');
          width: 20px;
          height: 20px;
        }
        .maestro {
          background-image: url('/a/fa/product/static/styles/svg/maestroIcon.svg');
          width: 26px;
          height: 12px;
        }
      }
    }
  }
`;

export { DeliveryOptionsSelectedTextStyle };
